// eslint-disable-next-line import/no-cycle
import { getUserData } from '@/auth/utils'
import { USER_TYPE_PARENT } from '@/const/userType'

export default function parentUsersOnly({ next, router }) {
  if (getUserData().usertype !== USER_TYPE_PARENT && getUserData().usertype !== 'super') {
    return router.push('not-authorized')
  }

  return next()
}
